import PouchDB from 'pouchdb'
import React, { useCallback } from 'react'
import { Button } from 'react-bootstrap'
import { TfiImport } from 'react-icons/tfi'

import { useDatabase } from '../../../../providers/database_provider'
import { sendBlob } from '../../../../utilities/blob_utils'
import { getInstallation } from '../../../../utilities/database_utils'
import {
    JSON_DOCUMENT_CONTENT_TYPE,
    JSON_DOCUMENT_FILE_EXTENSION,
    exportJSONInstallationDocument,
} from '../../../../utilities/json_serialization_utils'

interface ExportDocProps {
    installationId: PouchDB.Core.DocumentId
}

const ExportChildDoc: React.FC<ExportDocProps> = ({ installationId }) => {
    const db = useDatabase()

    const handleClick = useCallback(
        async (event: React.MouseEvent<HTMLButtonElement>) => {
            event.stopPropagation()
            event.preventDefault()

            const installationDoc = await getInstallation(db, installationId)

            const data = await exportJSONInstallationDocument(
                db,
                installationId,
            )

            const blob = new Blob([JSON.stringify(data)], {
                type: JSON_DOCUMENT_CONTENT_TYPE,
            })

            const fileName = `Site Visit - ${installationDoc.metadata_.doc_name} ${new Date().toUTCString()}${JSON_DOCUMENT_FILE_EXTENSION}`

            sendBlob(blob, fileName)

            return false
        },
        [db, installationId],
    )

    return (
        <Button variant="light" onClick={handleClick}>
            <TfiImport size={20} />
        </Button>
    )
}

export default ExportChildDoc
